// extracted by mini-css-extract-plugin
module.exports = {"cp-price-list__row":"styles_cp-price-list__row__1Esch","cp-price-list__row--disabled":"styles_cp-price-list__row--disabled__1KEQR"};